import {
  PIIScanItemGrouped,
  PIIScanItemGroupedMetadataArgs,
  getPIIScanItemGroupedListMetadata,
} from '../../assets/ts/data/pii/pii-scan-item-grouped'
import useServerData from '../use-server-data'

function usePiiScanItemGroupedMetadata(
  fetchArgs,
  waitOnParentDependency = false
) {
  const {
    data: piiScanItemGroupedMetadata,
    error: piiScanItemGroupedMetadataError,
    fetchData: fetchpiiScanItemGroupedMetadata,
    isLoading: piiScanItemGroupedMetadataIsLoading,
  } = useServerData<PIIScanItemGrouped, PIIScanItemGroupedMetadataArgs>(
    getPIIScanItemGroupedListMetadata,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchpiiScanItemGroupedMetadata,
    piiScanItemGroupedMetadata,
    piiScanItemGroupedMetadataError,
    piiScanItemGroupedMetadataIsLoading,
  }
}

export default usePiiScanItemGroupedMetadata
